/**
 * Created by petr on 30.12.14.
 */

/**
 * Соединение клиентов, работа с формированием списков
 */
$(document).ready(function () {
    sendFilteredMailButtonTextDefault = $('a#send-filtered-mail span.whom-to-send').text();

    $('#clients').on('change', '[name^="merge"]', function (e) {
        e.stopPropagation();
        var length = $('[name^="merge"]:checked').length,
            $sendFilteredMailButtonText = $('a#send-filtered-mail span.whom-to-send'),
            $setManagerButtonText = $('a#set-manager-button span.set-manager-button-label'),
            $setManagerButton = $('div#set-manager');

        if (length > 0) {
            // Актуализация кнопки формирования списка рассылки
            $sendFilteredMailButtonText.text(' письмо ' + length + ' ' + GetStrNumEnd(length, 'клиенту', 'клиентам', 'клиентам'));
        } else {
            $sendFilteredMailButtonText.text(sendFilteredMailButtonTextDefault);
        }

        if (length > 1) {
            // Кнопка объединения клиентов
            if (0 == $('#merge').length) {
                $('body').append('<div id="merge"/>');
            }

            var $merge = $('#merge');

            $merge.empty();
            $merge.append('<a id="merge-do">Объединить ' + length + ' ' + GetStrNumEnd(length, 'клиент', 'клиента', 'клиентов') + '</a>');
            $merge.append('<a id="merge-undo">Снять все галочки</a>');

            // Кнопка массового назначения менеджеров
            $setManagerButtonText.text('Поменять менеджера для ' + length + ' ' + GetStrNumEnd(length, 'клиента', 'клиентов', 'клиентов'));
            $setManagerButton.show();
        } else {
            $('#merge').remove();
            $setManagerButton.hide();
        }

    }).parent().on('click', function (e) {
        e.stopPropagation();
    });
});